module.exports = __webpack_public_path__ + "static/media/W00F0004.ceb794fe.svg";